<template>
  <div class="align-items-center justify-content-center tutorial-popup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="tutorial-wrapper">

          <div class="tutorial-window">
            <div class="header"></div>
            <div class="content">
              <TutorialPage
                  v-for="page in pages"
                  :key="page.id"
                  v-show="currentPageId === page.id"
                  :title="page.title"
                  :body="page.body"
                  :image="page.image"
                  :isFirstPage="page.id === 0"
                  :isLastPage="page.id === pages.length-1"
                  :buddy="buddy"
                  :showBuddy="currentPageId === 0"
                  v-on:backClicked="backClicked()"
                  v-on:forwardClicked="forwardClicked()"
              ></TutorialPage>
              <div class="pips">
                <button class="pip btn" v-for="page in pages"
                        :key="page.id"
                        :class="currentPageId === page.id? 'large' : '' "
                        @click="pipClicked(page.id)"
                ></button>
              </div>

            </div>
            <div class="footer"></div>
          </div>

          <div class="button-row">

            <WhiteOutlineButton :buttonText="'Volgende'" :stretch-to-fill="false"
                                v-on:clicked="nextStepClicked"></WhiteOutlineButton>

          </div>

        </div>
      </transition>

    </div>
  </div>

</template>

<script>

  import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
  import TutorialPage from "@/components/StudentPlatform/Onboarding/TutorialPage";

  import tutorial5 from '@/assets/image/tutorial/platform_01_ongezond.png';
  import tutorial6 from '@/assets/image/tutorial/platform_02_notificatie.png';
  import tutorial7 from '@/assets/image/tutorial/platform_03_level.png';
  import tutorial8 from '@/assets/image/tutorial/platform_04_personaliseer.png';


  export default {
    name: "Tutorial2",
    components: {WhiteOutlineButton, TutorialPage},
    props: {
      open: Boolean,
      buddyName: String,
      buddy: Object,
    },
    data() {
      return {
        show: false,
        videoLoaded: false,

        currentPageId: 0,

        pages: [
          {
            id: 0,
            title: "OEI, " + this.buddyName.toUpperCase() + " ZIET ER NIET GOED UIT",
            body: this.buddyName + " ziet er momenteel futloos uit. De vacht van " + this.buddyName + " is grauw en dof. Geven jullie " + this.buddyName + " ook wat extra energie? Door beweegopdrachten te doen zal " + this.buddyName + " er beter uitzien en fitter worden.",
            image: tutorial5,
          },
          {
            id: 1,
            title: "NIEUWE ACTIVITEITEN",
            body: "LUUK heeft een nieuwe opdracht voor jullie en " + this.buddyName + " wanneer het icoontje oplicht. Probeer de opdracht zo goed mogelijk uit te voeren om energie te verdienen voor de teletijdsmachine.",
            image: tutorial6,
          },
          {
            id: 2,
            title: "LEVEL OMHOOG",
            body: "Telkens de teletijdsmachine volledig vol is kan "+ this.buddyName + " informatie naar de toekomst sturen. Daar wordt "+ this.buddyName + " zelf ook gezonder, blij en energieker van. "+ this.buddyName + " stijgt een level en krijgt een beloning uit de toekomst.",
            image: tutorial7,
          },

          {
            id: 3,
            title: "GADGETS PASSEN",
            body: this.buddyName + " kan gadgets passen via de opgelichte knop. Hiermee zie je alle beloningen die " + this.buddyName + " al heeft ontvangen van zijn vrienden in de toekomst.",
            image: tutorial8,
          },
        ]
      }
    },
    computed: {},
    mixins: [],
    methods: {

      closeClicked() {
        this.$emit("closeClicked");
      },

      onReady() {
        this.videoLoaded = true;
      },

      //#region carousel

      backClicked()
      {
        if (this.currentPageId <= 0)
        {
          this.currentPageId = this.pages.length - 1;
        }
        else
        {
          this.currentPageId--;
        }
      },


      forwardClicked()
      {
        if (this.currentPageId >= this.pages.length - 1)
        {
          this.currentPageId = 0;
        }
        else
        {
          this.currentPageId++;
        }
      },

      pipClicked(id) {
        this.currentPageId = id;
      },

      //#endregion

      backToVideoClicked()
      {
        if (this.currentPageId <= 0)
        {
          this.$emit("backToVideo");
        }
        else
        {
          this.currentPageId--;
        }
      },

      nextStepClicked()
      {
        if (this.currentPageId >= this.pages.length - 1)
        {
          this.$emit("nextStepClicked");
        }
        else
        {
          this.currentPageId++;
        }
      }


    },
    mounted() {
      let that = this;
      that.show = true;
    },
    created() {
    },
  }


</script>

<style lang="scss" scoped>

  .tutorial-popup {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    top: 0;
    left: 0;
    display: flex;

    .popup-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .tutorial-window {
    width: 50%;
    height: 50%;

    .header {
      background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: bottom center;
      width: 600px;
      height: calc(600px * 0.086);
    }

    .content {
      //content is now fixed to allow the use of the user's buddy in tutorial images
      width: 600px;

      //width: 50vw;
      //min-height: calc(80vh - (50vw * 0.086 * 2));
      background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
      background-size: 100%;
      background-position: center center;
      position: relative;
      padding: 25px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

    }

    .footer {
      background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: top center;

      width: 600px;
      height: calc(600px * 0.086);
    }

    .pips {
      display: flex;
      justify-content: center;
      align-items: center;

      .pip {
        width: 10px;
        height: 10px;
        padding: 0px;
        border-radius: 10px;
        background-color: white;
        margin: 5px;

        &.large {
          width: 15px;
          height: 15px;
        }
      }
    }
  }


  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  .button-row {
    height: 15%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

</style>